import * as signalR from '@microsoft/signalr';

export function buildAuthenticatedHubConnection(hubUrl: string, accessToken: string): signalR.HubConnection {
  return new signalR.HubConnectionBuilder()
    .withUrl(hubUrl, { accessTokenFactory: () => accessToken })
    .withAutomaticReconnect()
    .build();
}
